<template>
  <div class="customer-component" v-if="showPage">
    <div class="user-card">
      <UserCard
        :isCreate="isCreate"
        :config="userCardConfig"
        @saveSuccess="getData()"
      ></UserCard>
    </div>

    <template v-if="!isCreate">
      <div class="table-box">
        <div class="table-title flex-between">
          <div class="left">
            <div class="label">
              {{ $lange == "en" ? "Customer Contact" : "客户联系人" }}
            </div>
          </div>
          <div>
            <el-button
              class="add-contacts"
              size="mini"
              @click="addContactFlag = true"
              icon="el-icon-plus"
              >{{ $lange == "en" ? "Create Contact" : "添加联系人" }}</el-button
            >
            <el-button
              :icon="
                contactsTableShow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
              "
              class="show-btn"
              size="mini"
              @click="showTable('contactsTableShow')"
            >
              <template v-if="$lange == 'en'">{{
                contactsTableShow ? "hide" : "show"
              }}</template>
              <template v-else>{{
                contactsTableShow ? "收起" : "展开"
              }}</template>
            </el-button>
          </div>
        </div>
        <el-collapse-transition>
          <div class="table-content" v-show="contactsTableShow">
            <cc-table
              :config="contactsTableConfig"
              :params="contactsTableParams"
              :refesh-params="refeshTable"
              :loadData="!isCreate"
            ></cc-table>
          </div>
        </el-collapse-transition>
      </div>
      <div class="table-box">
        <div class="table-title flex-between">
          <div class="left">
            <div class="label">
              {{ $lange == "en" ? "Customer Product List" : "客户产品列表" }}
            </div>
          </div>
          <div>
            <el-button
              class="add-contacts"
              size="mini"
              icon="el-icon-plus"
              @click="goPage('ProductCreate')"
              >{{ $lange == "en" ? "Create Product" : "创建产品" }}</el-button
            >
            <el-button
              class="add-contacts"
              style="margin-left: 15px"
              size="mini"
              icon="el-icon-sort"
              @click="assoProduct = true"
              >{{ $lange == "en" ? "Related Products" : "关联产品" }}</el-button
            >
            <el-button
              :icon="
                productTableShow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
              "
              class="show-btn"
              size="mini"
              @click="showTable('productTableShow')"
            >
              <template v-if="$lange == 'en'">{{
                productTableShow ? "hide" : "show"
              }}</template>
              <template v-else>{{
                productTableShow ? "收起" : "展开"
              }}</template>
            </el-button>
          </div>
        </div>
        <el-collapse-transition>
          <div class="table-content" v-show="productTableShow">
            <cc-table
              :config="productTableConfig"
              :params="productTableParams"
              :refesh-params="productRefeshTable"
              :loadData="!isCreate"
            ></cc-table>
          </div>
        </el-collapse-transition>
      </div>

      <el-row type="flex">
        <el-col :span="13">
          <div class="echarts-box">
            <div class="title flex-between">
              <p>
                {{ $lange == "en" ? "Cost/Revenue Tracking" : "成本/收入跟踪" }}
              </p>
              <el-date-picker
                value-format="yyyy"
                v-model="incomeDate"
                align="right"
                type="year"
                size="mini"
                placeholder="选择年"
              ></el-date-picker>
            </div>
            <template v-if="isCreate">
              <div class="not-data flex-between">
                {{ $lange == "en" ? "No Data" : "暂无数据" }}
              </div>
            </template>
            <template v-else>
              <div class="echarts" id="echarts-income"></div>
            </template>
          </div>
        </el-col>
        <el-col style="flex: 1; margin-left: 5px">
          <div class="echarts-box">
            <div class="title flex-between">
              <p>支出/成本占比</p>
              <el-date-picker
                value-format="yyyy"
                v-model="incomePieDate"
                align="right"
                type="year"
                size="mini"
                placeholder="选择年"
              ></el-date-picker>
            </div>
            <template v-if="isCreate">
              <div class="not-data flex-between">
                {{ $lange == "en" ? "No Data" : "暂无数据" }}
              </div>
            </template>
            <template v-else>
              <div class="echarts" id="echarts-income-pic"></div>
            </template>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex">
        <el-col :span="13">
          <div class="echarts-box">
            <div class="title flex-between">
              <p>
                {{
                  $lange == "en" ? "Request Quantity Tracking" : "请求数量跟踪"
                }}
              </p>
              <el-date-picker
                value-format="yyyy"
                v-model="workDate"
                align="right"
                type="year"
                size="mini"
                placeholder="选择年"
              ></el-date-picker>
            </div>
            <template v-if="isCreate">
              <div class="not-data flex-between">
                {{ $lange == "en" ? "No Data" : "暂无数据" }}
              </div>
            </template>
            <template v-else>
              <div class="echarts" id="echarts-work"></div>
            </template>
          </div>
        </el-col>
        <el-col style="flex: 1; margin-left: 5px">
          <div class="echarts-box">
            <div class="title flex-between">
              <p>{{ $lange == "en" ? "Requests Status" : "请求状态" }}</p>
              <el-date-picker
                value-format="yyyy"
                v-model="workPieDate"
                align="right"
                type="year"
                size="mini"
                placeholder="选择年"
              ></el-date-picker>
            </div>
            <template v-if="isCreate">
              <div class="not-data flex-between">
                {{ $lange == "en" ? "No Data" : "暂无数据" }}
              </div>
            </template>
            <template v-else>
              <div class="echarts" id="echarts-work-pie"></div>
            </template>
          </div>
        </el-col>
      </el-row>
      <div class="table-box">
        <div class="table-title flex-between">
          <div class="left">
            <div class="label">
              {{ $lange == "en" ? "History Request" : "历史请求明细" }}
            </div>
          </div>
          <el-button
            :icon="historyTableShow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            class="show-btn"
            size="mini"
            @click="showTable('historyTableShow')"
          >
            <template v-if="$lange == 'en'">{{
              historyTableShow ? "hide" : "show"
            }}</template>
            <template v-else>{{ historyTableShow ? "收起" : "展开" }}</template>
          </el-button>
        </div>
        <el-collapse-transition>
          <div class="table-content" v-show="historyTableShow">
            <cc-table
              :config="historyTableConfig"
              :params="historyTableParams"
              :load-data="historyTableParams.customerId.length > 0"
            ></cc-table>
          </div>
        </el-collapse-transition>
      </div>
    </template>
    <el-dialog
      :title="$lange == 'en' ? 'Create Contact' : '添加联系人'"
      :visible.sync="addContactFlag"
      width="40%"
      @closed="dialogClose"
      append-to-body
    >
      <div>
        <el-form
          :model="form"
          size="mini"
          :label-width="$lange == 'en' ? '120px' : '100px'"
          :rules="formRule"
          ref="formRule"
          v-loading="formLoading"
        >
          <el-form-item
            :label="$lange == 'en' ? 'Contact' : '联系人'"
            prop="contactName"
          >
            <el-input
              v-model="form.contactName"
              :placeholder="
                $lange == 'en' ? 'Please enter contact' : '请输入联系人'
              "
            ></el-input>
          </el-form-item>

          <el-form-item :label="$lange == 'en' ? 'Title' : '职位'">
            <el-input
              v-model="form.position"
              :placeholder="
                $lange == 'en' ? 'Please enter title' : '请输入职位'
              "
            ></el-input>
          </el-form-item>

          <el-form-item
            :label="$lange == 'en' ? 'Mobile' : '联系方式'"
            prop="phone"
          >
            <el-input
              v-model="form.phone"
              :placeholder="
                $lange == 'en' ? 'Please enter mobile' : '请输入联系方式'
              "
            ></el-input>
          </el-form-item>

          <el-form-item :label="$lange == 'en' ? 'Telephone' : '办公座机'">
            <el-input
              v-model="form.officePhone"
              :placeholder="
                $lange == 'en' ? 'Please enter telephone' : '请输入办工座机'
              "
            ></el-input>
          </el-form-item>

          <el-form-item :label="$lange == 'en' ? 'E-mail' : '邮箱'">
            <el-input
              v-model="form.email"
              :placeholder="
                $lange == 'en' ? 'Please enter E-mail' : '请输入邮箱'
              "
            ></el-input>
          </el-form-item>
          <el-form-item :label="$lange == 'en' ? 'Remark' : '备注'">
            <el-input
              v-model="form.remark"
              :placeholder="
                $lange == 'en' ? 'Please enter remark' : '请输入备注'
              "
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('formRule')">{{
              $lange == "en" ? "Submit" : "提交"
            }}</el-button>
            <el-button @click="cancelForm('formRule')">{{
              $lange == "en" ? "Cancel" : "取消"
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog
      title="产品列表"
      :visible.sync="assoProduct"
      width="40%"
      @closed="dialogClose"
      append-to-body
    >
      <el-input
        v-model="assoProductTableParams.jobId"
        style="width: 150px; margin-bottom: 15px"
        size="mini"
        placeholder="Job ID"
      ></el-input>
      <cc-table
        :config="assoProductTableConfig"
        :params="assoProductTableParams"
      ></cc-table>
    </el-dialog>

    <el-dialog
      :visible.sync="detailsDialog"
      :fullscreen="true"
      :title="$lange == 'en' ? 'Details' : '详情'"
      @closed="dialogClose"
      append-to-body
    >
      <template v-if="detailsDialog">
        <OrderDescriptionView
          :orderIdV2="detailsId"
          :isDialog="true"
        ></OrderDescriptionView>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import UserCard from "../../../components/UserCard";
import Echarts from "echarts";
import moment from "moment";
import OrderDescriptionView from "../../order/OrderDescription.vue";

export default {
  name: "CustomerComponent",
  components: {
    UserCard,
    OrderDescriptionView,
  },
  props: {
    isCreate: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    workDate: {
      handler() {
        this.workInit();
      },
    },
    workPieDate: {
      handler() {
        this.workPieInit();
      },
    },
    incomeDate: {
      handler() {
        this.incomeInit();
      },
    },
    incomePieDate: {
      handler() {
        this.incomePieInit();
      },
    },
  },
  data() {
    return {
      detailsDialog: false,
      detailsId: "",
      showPage: false,
      assoProduct: false,
      assoProductTableParams: {
        jobId: "",
      },
      assoProductTableConfig: {
        api: "admin/fsb/product/queryByCustomerIsNull",
        showPager: false,
        columns: [
          {
            prop: "jobId",
            lable: "Job ID",
            type: "input",
          },
          {
            prop: "productLine",
            lable: "产线",
            type: "input",
          },
          {
            prop: "breadth",
            lable: "幅宽",
            type: "input",
          },
          {
            prop: "speed",
            lable: "速度",
            type: "input",
          },
        ],
        buttons: [
          {
            name: "添加",
            click: (row) => {
              return (() => {
                let data = row;
                data.customerId = this.userCardConfig.id;
                this.ccRequest
                  .do("admin/fsb/product/save", data, "POSTJSON")
                  .then((res) => {
                    this.$message({
                      message: "添加成功",
                      type: "success",
                    });
                    this.productRefeshTable = new Date().getTime();
                  });
              })();
            },
          },
        ],
      },
      productRefeshTable: -1, //关联产品表格刷新
      addContactFlag: false, //添加联系人弹窗
      refeshTable: -1, //添加联系人表格刷新
      editContactId: false, //当前是否编辑联系人
      formLoading: false,
      form: {
        //添加联系人的表单
        contactName: "",
        position: "",
        phone: "",
        officePhone: "",
        email: "",
        remark: "",
      },
      formRule: {
        //表单验证规则
        contactName: [
          {
            required: true,
            message:
              this.$lange == "en" ? "Please enter contact" : "请输入联系人",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message:
              this.$lange == "en" ? "Please enter mobile" : "请输入联系方式",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: false,
            type: "email",
            message: this.$lange == "en" ? "Please enter E-mail" : "请输入邮箱",
            trigger: "blur",
          },
        ],
      },
      contactsTableShow: false, //控制表格
      productTableShow: false, //控制
      historyTableShow: false, //控制
      historyTableParams: {
        customerId: "",
        pageSize: 999,
      },
      historyTableConfig: {
        api: "admin/fsb/work/order/query",
        showPager: false,
        // dragState: true,
        columns: [
          {
            prop: "id",
            lable: "Care ID",
          },
          {
            prop: "jobId",
            lable: "Job ID",
          },
          {
            prop: "priority",
            lable: "Priority",
          },
          {
            prop: "product.status",
            lable: "ProductStatus",
            // type: "tag",
            // options: [
            //   { tagType: "info", text: "新增" },
            //   { tagType: "warning", text: "安装" },
            //   { tagType: "success", text: "保内" },
            //   { tagType: "danger", text: "保外" },
            // ],
            type: "constant",
            constantConfig: {
              code: "productStatus",
              api: "admin/dict/pageTree",
              opts: { 0: "info", 1: "warning", 2: "success", 3: "danger" },
            },
            minWidth: this.$lange == "en" ? 130 : 80,
          },

          {
            prop: "customer.customerName",
            lable: "Customer",
          },
          {
            prop: "handlerName",
            lable: "Contact",
          },
          {
            prop: "machine.machineModel",
            lable: "Machine",
          },
          {
            prop: "machine.fiCom",
            lable: "COM",
          },
          {
            prop: "title",
            lable: "Subject",
          },
          {
            prop: "userName",
            lable: "CareManager",
          },
          {
            prop: "status",
            lable: "Status",
            type: "constant",
            constantConfig: {
              code: "orderStatus",
              api: "admin/dict/pageTree",
              opts: {
                0: "info",
                1: "warning",
                2: "warning",
                3: "success",
                4: "success",
                5: "info",
              },
            },
          },
          {
            prop: "malfunctionAttribute.name",
            lable: "Classification",
          },
          {
            lable: "Last update",
            render: (row) => {
              return moment(row.updateTime).format("YYYY-MM-DD");
            },
          },
          {
            lable: "Created",
            render: (row) => {
              return moment(row.createTime).format("YYYY-MM-DD");
            },
          },
        ],
        buttons: [
          {
            name: "详情",
            click: (row) => {
              this.detailsId = row.id;
              this.detailsDialog = true;
              // this.$router.push({
              //   path: "/admin/order/des",
              //   query: {
              //     id: row.id,
              //   },
              // });
            },
          },
        ],
      },
      userCardConfig: {
        id: false,
        api: "admin/fsb/customer/save",
        customerName: "", // 公司的中文名称
        englishName: "", // 公司的英文名称
        image: "", //图片
        formLists: [
          //表单内容
          {
            name: "客户ID",
            value: "",
            type: "input",
            placeholder: "请输入客户id",
            required: true,
            key: "customerNo",
          },
          {
            name: "信用等级",
            value: "",
            type: "constant-select",
            placeholder:
              this.$lange == "en" ? "Credit level" : "请选择信用等级",
            key: "creditLevel",
          },
          {
            name: "年度满意度",
            value: "",
            type: "input",
            disabled: true,
            key: "annualSatisfaction",
          },
          {
            name: "配件折扣",
            value: "",
            type: "input",
            required: true,
            placeholder: "请输入0 ~ 1折扣",
            key: "discount",
          },

          {
            name: "客户经理",
            value: "",
            type: "input",
            placeholder: "请输入",
            key: "customerManager",
          },
          {
            name: "创建时间",
            type: "input",
            value: "",
            disabled: true,
            key: "createTime",
          },
          {
            name: "地址",
            value: "",
            type: "address",
            width: "300",
            placeholder: "请输入地址",
            key: "customerAddress",
          },
        ],
        postKey: [
          "customerNo",
          "creditLevel",
          "customerAddress",
          "customerManager",
          "annualSatisfaction",
          "discount",
          "customerName",
          "englishName",
          "image",
        ],
      },
      contactsTableConfig: {
        api: "admin/fsb/customer/contact/query",
        showPager: false,
        // dragState: true,
        columns: [
          {
            prop: "contactName",
            lable: this.$lange == "en" ? "Contact" : "联系人",
            type: "input",
            editAble: true,
            required: true,
          },
          {
            prop: "position",
            lable: this.$lange == "en" ? "Title" : "职位",
            type: "input",
            editAble: true,
            required: true,
          },
          {
            prop: "phone",
            lable: this.$lange == "en" ? "Mobile" : "联系方式",
            type: "input",
            editAble: true,
            required: true,
          },
          {
            prop: "officePhone",
            lable: this.$lange == "en" ? "Telephone" : "办公座机",
            editAble: true,
            type: "input",
            required: true,
          },
          {
            prop: "email",
            lable: this.$lange == "en" ? "E-mail" : "邮箱",
            type: "input",
            editAble: true,
            required: true,
          },
          {
            prop: "inviteCode",
            lable: this.$lange == "en" ? "Invitation code" : "邀请码",
            render: (row) => {
              let res = "未生成";
              if (row.inviteCode.length > 0) {
                res = row.inviteCode;
              }
              return res;
            },
          },
          {
            prop: "remark",
            lable: this.$lange == "en" ? "Remark" : "备注",
            type: "input",
            editAble: true,
            required: true,
          },
        ],
        buttonsLabel: this.$lange == "en" ? "Operating" : "操作",
        buttons: [
          {
            name: this.$lange == "en" ? "Create code" : "生成邀请码",
            check: (row) => {
              let res = true;
              if (row.inviteCode != undefined && row.inviteCode.length > 0) {
                res = false;
              }
              return res;
            },
            click: (row) => {
              let data = {
                userPhone: row.phone,
                size: 6,
              };
              this.ccRequest
                .do("admin/fsb/invite/code/save", data, "POSTJSON")
                // eslint-disable-next-line no-unused-vars
                .then((res) => {
                  this.$message({
                    type: "success",
                    message: "邀请码已生成",
                  });
                  this.refeshTable = new Date().getTime();
                });
            },
          },
          {
            name: this.$lange == "en" ? "Edit" : "编辑",
            click: (row) => {
              this.editContact(row);
            },
          },
          {
            name: this.$lange == "en" ? "Delete" : "删除",
            click: (row) => {
              this.deleteContact(row.id);
            },
          },
          {},
          {},
        ],
      },
      contactsTableParams: {
        customerId: "",
        status: 0,
      },
      productTableConfig: {
        api: "admin/fsb/product/query",
        showPager: false,
        columns: [
          {
            prop: "jobId",
            lable: "Job ID",
            type: "input",
          },
          {
            prop: "customer.customerName",
            lable: this.$lange == "en" ? "Customer Name" : "客户名称",
          },
          {
            prop: "productLine",
            lable: this.$lange == "en" ? "Product Line" : "产线",
          },
          {
            prop: "breadth",
            lable: this.$lange == "en" ? "Width" : "幅宽",
          },
          {
            prop: "product.stackedLayers",
            lable: this.$lange == "en" ? "Stacked Layers" : "堆叠层数",
          },
          {
            prop: "product.corrugatedLayers",
            lable: this.$lange == "en" ? "Corrugated Layers" : "瓦楞层数",
          },
          {
            prop: "speed",
            lable: this.$lange == "en" ? "Speed" : "速度",
          },
        ],
        buttons: [
          {
            name: this.$lange == "en" ? "View Detail" : "查看",
            click: (row) => {
              let query = {
                productId: row.id,
              };
              this.$router.push({
                path: "/admin/product/description",
                query: query,
              });
            },
          },
          {
            name: this.$lange == "en" ? "Delete" : "删除",

            click: (row) => {
              return (() => {
                this.$confirm("此操作会取消关联该产品, 是否确定?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                }).then(() => {
                  // let data = row;
                  // data.customerId = "";
                  this.ccRequest
                    .do("admin/fsb/product/delete", { id: row.id }, "GET")
                    .then((res) => {
                      console.log(res);
                      this.$message({
                        type: "success",
                        message: "删除成功!",
                      });
                      this.productRefeshTable = new Date().getTime();
                    })
                    .catch((res) => {
                      this.$message({
                        type: "warning",
                        message: res.response.data.message,
                      });
                    });
                });
              })();
            },
          },
          {},
          {},
          {},
        ],
      },
      productTableParams: {
        customerId: "",
      },
      customerId: "",
      incomeDate: "", //季度收入表 柱状图 日期
      incomePieDate: "", //季度收入表饼图 日期
      workDate: "", // 工单柱状图 日期
      workPieDate: "", //工单饼图 日期
    };
  },
  methods: {
    formatterBar(params) {
      const t = Object.prototype.toString.call(params.value);
      if (t === "[object Array]") {
        const d = params.value[params.seriesIndex + 1];
        if (!d || d == 0) return "";
        else return d;
      }
    },
    goPage(name) {
      this.$router.push({
        name: name,
      });
    },
    // eslint-disable-next-line no-unused-vars
    addAssoProduct(row) {},
    editContact(row) {
      this.editContactId = row.id;
      for (let i in this.form) {
        this.form[i] = row[i];
      }
      this.addContactFlag = true;
    },
    deleteContact(id) {
      this.$confirm("此操作会删除该联系人并且绑定的优惠码不可使用, 是否确定?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.ccRequest
            .do("admin/fsb/customer/contact/delete", { id: id }, "GET")
            .then((res) => {
              console.log(res);
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.refeshTable = new Date().getTime();
            });
        })
        .catch(() => {
          // this.$message({
          //     type: 'info',
          //     message: '已取消删除'
          // });
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.formLoading = true;
          let data = this.form;
          let text = "添加成功";
          if (this.editContactId) {
            data.id = this.editContactId;
            text = "编辑成功";
          }
          data.customerId = this.userCardConfig.id;
          this.ccRequest
            .do("admin/fsb/customer/contact/save", data, "POSTJSON")
            .then((res) => {
              console.log(res);
              this.formLoading = false;
              this.addContactFlag = false;
              this.$message({
                message: text,
                type: "success",
              });
              this.editContactId = false;
              this.refeshTable = new Date().getTime();
            })
            .catch((res) => {
              this.formLoading = false;
              this.$message({
                message: res.response.data.message,
                type: "error",
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    cancelForm(formName) {
      this.$refs[formName].resetFields();
      this.addContactFlag = false;
    },
    dialogClose() {
      for (let i in this.form) {
        this.form[i] = "";
      }
    },
    getData() {
      if (this.isCreate) {
        this.showPage = true;
        return false;
      }
      console.log("start", this.userCardConfig.id);
      let data = {
        id: this.userCardConfig.id,
      };
      this.ccRequest.do("admin/fsb/customer/get", data, "GET").then((res) => {
        console.log(this.userCardConfig);
        for (let j in this.userCardConfig.formLists) {
          for (let i in res) {
            // console.log(this.cardConfig.formLists[j].key, "aaa", i, "bbb")
            if (
              this.userCardConfig.formLists[j].key &&
              this.userCardConfig.formLists[j].key == i
            ) {
              if (i === "discount") {
                res[i] /= 10;
              }
              this.userCardConfig.formLists[j].value = res[i];
            }
          }
        }
        this.userCardConfig.image = res.imageUrl;
        this.userCardConfig.customerName = res.customerName;
        this.userCardConfig.englishName = res.englishName;
        this.productTableParams.customerId = res.id;
        this.customerId = res.id;
        this.initEcharts();
      });
    },
    showTable(tableType) {
      if (this.isCreate) {
        this.$alert("客户未创建，暂无数据", "温馨提示");
        return false;
      }
      this[tableType] = !this[tableType];
    },
    incomeInit() {
      const quarters = ["", "第一季度", "第二季度", "第三季度", "第四季度"];
      let data = {
        customerId: this.customerId,
        year: this.incomeDate,
      };
      this.ccRequest
        .do("admin/fsb/customer/quarterlyCost", data, "GET")
        .then((res) => {
          console.log("成本/收入跟踪", res);
          let source = [["product", "支出", "收入"]];
          source[0] = ["product", "支出", "收入"];
          // for (let i in res) {
          //   let item = res[i];
          //   source[i*1+1] = [
          //     item.year+"年" ,
          //     item.cost / 100,
          //     item.income / 100,
          //   ]
          // }
          for (let i in res) {
            let item = res[i];
            source[i * 1 + 1] = [
              `${quarters[item.quarter]}`,
              item.cost / 100,
              item.income / 100,
            ];
          }
          console.log(source, "source");
          if (res.length == 0) {
            source[1] = [this.incomeDate + "年", 0, 0];
          }
          /* 客户页面的季度柱状图 */
          let option = {
            legend: {},
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            dataset: {
              source: source,
              itemStyle: {},
            },
            xAxis: { type: "category" },
            yAxis: {},
            // Declare several bar series, each will be mapped
            // to a column of dataset.source by default.
            series: [
              {
                type: "bar",
                color: "#555555",
                barWidth: "25px",
                label: {
                  show: true,
                  position: "top",
                  formatter: this.formatterBar,
                },
              },
              {
                type: "bar",
                color: "#49a9ee",
                barWidth: "25px",
                label: {
                  show: true,
                  position: "top",
                  formatter: this.formatterBar,
                },
              },
            ],
          };
          this.incomeCanvas = Echarts.init(
            document.getElementById("echarts-income")
          );
          this.incomeCanvas.setOption(option);
        });
    },
    incomePieInit() {
      let data = {
        customerId: this.customerId,
        year: this.incomePieDate,
      };
      this.ccRequest
        .do("admin/fsb/customer/revenueShare", data, "GET")
        .then((res) => {
          console.log(res, "支出/成本占比");
          /* 客户页面的饼图 */
          let option = {
            tooltip: {
              trigger: "item",
              /**
               * @b name
               * @c value
               * @d angle
               * */
              formatter: "{b} : {c} ({d}%)",
            },
            series: [
              {
                type: "pie",
                radius: "65%",
                center: ["50%", "50%"],
                data: [
                  {
                    value: res.costFee / 100,
                    name: "支出费用总计",
                    label: {
                      formatter: "{b} : {c} ({d}%)",
                    },
                    itemStyle: {
                      color: "#ffd86e",
                    },
                  },
                  {
                    value: res.incomeFee / 100,
                    name: `收入费用总计`,
                    label: {
                      formatter: "{b} : {c} ({d}%)",
                    },
                    itemStyle: {
                      color: "#2db6f4",
                    },
                  },
                ],
                itemStyle: {
                  emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
              },
            ],
          };
          this.incomePicCanvas = Echarts.init(
            document.getElementById("echarts-income-pic")
          );
          this.incomePicCanvas.setOption(option);
        });
    },
    workInit() {
      let data = {
        customerId: this.customerId,
        year: this.workDate,
      };
      this.ccRequest
        .do("admin/fsb/customer/workOrderSituation", data, "GET")
        .then((res) => {
          console.log(res, "请求数量跟踪");
          let value = [];
          let xAxis = [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月",
          ];
          value = xAxis.map((mon, idx) => {
            const month = idx + 1;
            const inMonth = res.find((obj) => obj.month == month);
            if (!inMonth) return 0;
            return inMonth.count;
          });
          // for (let j = 0; j < res.length; j++) {
          //   value.push( res[j].count);
          //   // xAxis.push(res[j].year+'年')
          //   // 改成月份 2021.11.05
          //   xAxis.push(`${res[j].month}月`)
          // }

          if (res.length == 0) {
            value.push(0);
            //  xAxis.push(this.workDate+'月')
            //  xAxis.push(this.workDate+'年')
          }

          /* 客户页面的月份柱状图 */
          let option = {
            color: ["#49a9ee"],
            tooltip: {
              trigger: "axis",
              axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
              },
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true,
            },
            xAxis: [
              {
                type: "category",
                data: xAxis,
                axisTick: {
                  alignWithLabel: true,
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                name: "次数(单位次)",
              },
            ],
            series: [
              {
                name: "工单请求数",
                type: "bar",
                barWidth: "20%",
                data: value,
              },
            ],
          };
          this.incomeCanvas = Echarts.init(
            document.getElementById("echarts-work")
          );
          this.incomeCanvas.setOption(option);
        });
    },
    workPieInit() {
      let data = {
        customerId: this.customerId,
        year: this.workPieDate,
      };
      this.ccRequest
        .do("admin/fsb/customer/workOrderStatus", data, "GET")
        .then((res) => {
          console.log(res, "请求状态");
          /* 客户页面的饼图 unprocessed (未处理),processing (处理中)，solved (已解决)*/
          let option = {
            tooltip: {
              trigger: "item",
              /**
               * @b name
               * @c value
               * @d angle
               * */
              formatter: "{b} : {c} ({d}%)",
            },
            series: [
              {
                type: "pie",
                radius: "65%",
                center: ["50%", "50%"],
                data: [
                  {
                    value: res.init || 0,
                    name: "未处理",
                    label: {
                      formatter: "{b} : {c} ({d}%)",
                    },
                    itemStyle: {
                      color: "#81d3f8",
                    },
                  },
                  {
                    value: res.processing || 0,
                    name: `处理中`,
                    label: {
                      formatter: "{b} : {c} ({d}%)",
                    },
                    itemStyle: {
                      color: "#49a9ee",
                    },
                  },
                  {
                    value: res.observation || 0,
                    name: `观察中`,
                    label: {
                      formatter: "{b} : {c} ({d}%)",
                    },
                    itemStyle: {
                      color: "#49f9ea",
                    },
                  },
                  {
                    value: res.finish || 0,
                    name: `已完成`,
                    label: {
                      formatter: "{b} : {c} ({d}%)",
                    },
                    itemStyle: {
                      color: "#e6c163",
                    },
                  },
                  {
                    value: res.close || 0,
                    name: `已关闭`,
                    label: {
                      formatter: "{b} : {c} ({d}%)",
                    },
                    itemStyle: {
                      color: "#e6fa63",
                    },
                  },
                  {
                    value: res.cancel || 0,
                    name: `已取消`,
                    label: {
                      formatter: "{b} : {c} ({d}%)",
                    },
                    itemStyle: {
                      color: "#e6c1fa",
                    },
                  },
                ],
                itemStyle: {
                  emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
              },
            ],
          };
          this.incomePicCanvas = Echarts.init(
            document.getElementById("echarts-work-pie")
          );
          this.incomePicCanvas.setOption(option);
        });
    },
    initEcharts() {
      //如果是创建页面, 无需实例化图标
      if (this.isCreate) {
        return false;
      }
      let year = `${new Date().getFullYear()}`;
      this.workDate = year;
      this.workPieDate = year;
      this.incomeDate = year;
      this.incomePieDate = year;
    },
    //当前是英文页面,将表格参数替换成英文 图表的转换在每个初始化函数里
    checkLanguage() {
      if (this.$lange == "en") {
        this.userCardConfig = {
          id: false,
          api: "admin/fsb/customer/save",
          customerName: "", // 公司的中文名称
          englishName: "", // 公司的英文名称
          image: "", //图片
          formLists: [
            //表单内容
            {
              name: "Customer ID",
              value: "",
              type: "input",
              disabled: true,
              key: "id",
            },
            {
              name: "Credit",
              value: "",
              type: "constant-select",
              placeholder:
                this.$lange == "en" ? "Credit level" : "请选择信用等级",
              key: "creditLevel",
            },
            {
              name: "Satisfaction level",
              value: "",
              type: "input",
              disabled: true,
            },
            {
              name: "Spare Part Discount",
              value: "",
              type: "input",
              placeholder:
                this.$lange == "en" ? ":Discount given" : "请输入配件折扣",
              key: "discount",
            },

            {
              name: "Name",
              value: "",
              type: "input",
              placeholder: "请输入",
              key: "customerManager",
            },
            {
              name: "created at",
              type: "input",
              value: "",
              disabled: true,
              key: "createTime",
            },
            {
              name: "Address",
              value: "",
              type: "input",
              width: "300",
              placeholder: "请输入地址",
              key: "customerAddress",
            },
          ],
          postKey: [
            "creditLevel",
            "customerAddress",
            "customerManager",
            "annualSatisfaction",
            "discount",
            "customerName",
            "englishName",
            "image",
          ],
        };
        this.assoProductTableConfig = {
          api: "admin/fsb/product/queryByCustomerIsNull",
          showPager: false,
          columns: [
            {
              prop: "jobId",
              lable: "Job ID",
              type: "input",
            },
            {
              prop: "productLine",
              lable: "Product Line",
              type: "input",
            },
            {
              prop: "breadth",
              lable: "Width",
              type: "input",
            },
            {
              prop: "speed",
              lable: "Speed",
              type: "input",
            },
          ],
          ButtonLabel: "Operating",
          buttons: [
            {
              name: "Add",
              click: (row) => {
                return (() => {
                  let data = row;
                  data.customerId = this.userCardConfig.id;
                  this.ccRequest
                    .do("admin/fsb/product/save", data, "POSTJSON")
                    .then((res) => {
                      this.$message({
                        message: "添加成功",
                        type: "success",
                      });
                    });
                })();
              },
            },
          ],
        };
        this.historyTableConfig = {
          api: "admin/fsb/work/order/query",
          showPager: false,
          // dragState: true,
          columns: [
            {
              prop: "id",
              lable: "Care ID",
            },
            {
              prop: "jobId",
              lable: "Job ID",
            },
            {
              prop: "priority",
              lable: "Priority",
            },
            {
              prop: "product.status",
              lable: "ProductStatus",
              type: "tag",
              options: [
                { tagType: "info", text: "New" },
                { tagType: "warning", text: "Installation" },
                { tagType: "success", text: "Under warranty" },
                { tagType: "danger", text: "Out of warranty" },
              ],
            },

            {
              prop: "customer.customerName",
              lable: "Customer",
            },
            {
              prop: "handlerName",
              lable: "Contact",
            },
            {
              prop: "machine.machineModel",
              lable: "Machine",
            },
            {
              prop: "machine.fiCom",
              lable: "COM",
            },
            {
              prop: "title",
              lable: "Subject",
            },
            {
              prop: "userName",
              lable: "CareManager",
            },
            {
              prop: "status",
              lable: "Status",
              type: "constant",
              constantConfig: {
                code: "orderStatus",
                api: "admin/dict/pageTree",
                opts: {
                  0: "info",
                  1: "warning",
                  2: "warning",
                  3: "success",
                  4: "success",
                  5: "info",
                },
              },
            },
            {
              prop: "malfunctionAttribute.name",
              lable: "Classification",
            },
            {
              lable: "Last update",
              render: (row) => {
                return moment(row.updateTime).format("YYYY-MM-DD");
              },
            },
            {
              lable: "Created",
              render: (row) => {
                return moment(row.createTime).format("YYYY-MM-DD");
              },
            },
          ],
          buttonsLabel: "Operation",
          buttons: [
            {
              name: "Description",
              click: (row) => {
                this.detailsId = row.id;
                this.detailsDialog = true;
                // this.$router.push({
                //   path: "/admin/order/des",
                //   query: {
                //     id: row.id,
                //   },
                // });
              },
            },
            {},
          ],
        };
      }
    },
  },
  mounted() {
    this.checkLanguage();
    if (this.$route.query.customerId) {
      this.userCardConfig.id = this.$route.query.customerId;
      let params = {
        customerId: this.$route.query.customerId,
        pageSize: 999,
      };
      this.contactsTableParams = params;
      this.productTableParams = params;
      this.historyTableParams = params;
      this.showPage = true;
      this.getData();
    } else {
      this.showPage = true;
    }
  },
};
</script>
<style >
.customer-component .el-dialog__body {
  padding: 10px 20px 30px 20px;
}
</style>
<style lang="scss">
.el-tabs__content {
  padding: 0 !important;
}
.table-box {
  .el-card {
    border-top: 2px solid #f3f3f4;
  }
}
</style>

<style scoped lang="scss">
.customer-component {
  background: #f3f3f4;
  .table-box {
    background: #ffffff;
    margin-top: 5px;

    .table-title {
      padding: 10px 20px;

      .left {
        display: flex;
        align-items: center;
        .label {
          font-weight: bolder;
          font-size: 18px;
          color: #6f6f6f;
        }
        .add-contacts {
          font-size: 12px;
          padding: 5px;
          margin-left: 35px;
        }
      }

      .show-btn {
        font-size: 12px;
        background: #e4e4e4;
        color: #000;
        padding: 3px 10px;
        cursor: pointer;
      }
    }
  }
  .echarts-box {
    margin-top: 5px;
    background: #ffffff;
    .title {
      border-bottom: 1px solid #e4e4e4;
      padding: 10px 20px;
      font-size: 18px;
      font-weight: bolder;
      color: #6f6f6f;
    }
    .echarts {
      padding-top: 20px;
      height: 340px;
      display: flex;
      justify-content: center;
    }
    .not-data {
      height: 340px;
      justify-content: center;
      font-size: 22px;
      color: #e4e4e4;
    }
  }
}
</style>
